import {Component} from 'react';
import $ from "jquery";

import Analytics from "../../analytics";
import {getCurrentLayout} from "../appLayout";
import {changeQTRoutePath, changeRoutePath} from "../../misc/changeRoutePath";
import store from "../../store";
import {featureIsMatchingQtCatName} from "../../misc/categorySwitchingFunctions";
import {showWizardInsteadOfQT} from "../look/lookNavigation/lookMain/lookWizard/lookWizardFunctions";
import {switchToWizardItem} from "../qkbPages/materialsWizard/useChangeWizardStepRoute";

export default class CommonFeatureItemsMethods extends Component {

  // this method is NOT used by SelectionMainList, only visualizers desktop & mobile navigations
  switchToFeatureInfo = (feature, analyticsLabel, setCameFromPage = "shoppingcart", scrollToRelatedFeatureId = null, fromCartItem = null) => {

    Analytics.sendClickEvent(analyticsLabel);
    const featureInfo = feature.part || feature;
    const featureParent = featureInfo.getParent();
    const selectionGroup = featureParent.getParent ? featureParent.getParent().partName : featureParent.partName;
    const {fabricatorState, wizardState} = store.getState();
    const {wizardList, wizardIsActive} = wizardState;

    const visType = fabricatorState.settings.allowVisualizerSwitching && fromCartItem && fromCartItem.fromVisualizerType
      ? fromCartItem.fromVisualizerType
      : document.kvConfig.visualizerType;
    const layout = getCurrentLayout(visType);

    const setCommonStuff = () => {
      this.props.toggleSelectionWindow(true, selectionGroup);
      this.props.toggleSelectionFeatureInfo(featureInfo, true);
      if (setCameFromPage === "visualizer") {
        this.props.toggleBathroomVisualizerOpen(false);
      }
      this.props.setCameFromPage(setCameFromPage);
    }

    if (showWizardInsteadOfQT(wizardList, wizardIsActive)) {
      if (fromCartItem && fromCartItem.fromWizardId) {
        const wizardItem = wizardList.find(wizItem => wizItem.id === fromCartItem.fromWizardId);
        if (wizardItem) {
          setCommonStuff();
          switchToWizardItem(wizardItem, fromCartItem.fromWizardStep, fromCartItem.currentQuote, fromCartItem.fromWizardGroupId);
          return;
        }
      }
      const wizardItem = wizardList[0];
      if (wizardItem) {
        setCommonStuff();
        switchToWizardItem(wizardItem);
      }
      return
    }

    let nextCatName = "";

    // /* set new index*/
    let nextSubPartIndex = 0;
    if (featureParent.getParent) {
      if (layout.qtCategories
        && fabricatorState.settings.useCategorySwitching
        && layout.qtCategories.filter(qtCat => qtCat.subParts.some(subPart => subPart.part.partId === featureInfo.partId)).length > 1
        && fromCartItem
        && layout.qtCategories.find(qtCategory => featureIsMatchingQtCatName(fromCartItem.cartFeature, qtCategory.name, true))) {
        const neededCat = layout.qtCategories.find(qtCategory => featureIsMatchingQtCatName(fromCartItem.cartFeature, qtCategory.name, true));
        nextCatName = neededCat.name;
        nextSubPartIndex = neededCat.subParts.findIndex(subPart => subPart.part.partId === featureInfo.partId);
      } else if (layout.qtCategories && fromCartItem && fromCartItem.fromQtCategory
        && layout.qtCategories.find(qtCategory => qtCategory.name === fromCartItem.fromQtCategory)) {
        nextCatName = fromCartItem.fromQtCategory;
        this.props.setQtActiveCategory(fromCartItem.fromQtCategory);
        const qtActiveCategory = layout.qtCategories.find(qtCategory => qtCategory.name === fromCartItem.fromQtCategory);
        nextSubPartIndex = qtActiveCategory.subParts.findIndex(subPart => {
          return (subPart.part.dbName === featureParent.partName) || (subPart.part.partName === featureParent.partName)
        });
        if ((!nextSubPartIndex || nextSubPartIndex < 0) && qtActiveCategory.qtCategoryHasBeenChanged) {
          ["countertop", "edge", "faucet", "sink", "stovetop"].forEach(partId => {
            if (featureParent.partId.includes(partId)) {
              nextSubPartIndex = qtActiveCategory.subParts.findIndex(subPart => subPart.part.partId.includes(partId));
            }
          })
        }
      } else if (layout.qtCategories && featureParent.qtCategoryName) {
        this.props.setQtActiveCategory(featureParent.qtCategoryName);
        const qtActiveCategory = layout.qtCategories.find(qtCategory => qtCategory.name === featureParent.qtCategoryName);
        nextSubPartIndex = qtActiveCategory.subParts.findIndex(subPart => {
          return (subPart.part.dbName === featureParent.partName) || (subPart.part.partName === featureParent.partName)
        });
        if ((!nextSubPartIndex || nextSubPartIndex < 0) && qtActiveCategory.qtCategoryHasBeenChanged) {
          ["countertop", "edge", "faucet", "sink", "stovetop"].forEach(partId => {
            if (featureParent.partId.includes(partId)) {
              nextSubPartIndex = qtActiveCategory.subParts.findIndex(subPart => subPart.part.partId.includes(partId));
            }
          })
        }
      } else {
        const subParts = featureParent.getParent().subParts(false); // we don't need not visible subParts on the materials page
        const featureParentName = featureParent.partName.replace(/ /g,"-").toLowerCase();
        nextSubPartIndex = subParts.findIndex(subPartItem => {
          return subPartItem.part.partName.replace(/ /g,"-").toLowerCase() === featureParentName
        });
      }
    }

    if (!nextSubPartIndex || nextSubPartIndex < 0) {
      nextSubPartIndex = 0;
    }

    this.props.changeActivePartRelatedItemIndex(nextSubPartIndex);
    setCommonStuff();
    if (!window.location.href.includes('materials')) {
      if (layout.qtCategories && nextCatName) {
        changeQTRoutePath(nextCatName, nextSubPartIndex);
      } else if (layout.qtCategories && featureParent.qtCategoryName) {
        changeQTRoutePath(featureParent.qtCategoryName, nextSubPartIndex);
      } else {
        changeRoutePath(featureParent.getParent ? featureParent.getParent() : featureParent, nextSubPartIndex)
      }
    }
    if (scrollToRelatedFeatureId) {
      setTimeout(() => {
        const $scrollableDiv = $(".selection-main__info-scrollable");
        const scrollToArea = document.querySelector(".prod-associated");
        const scrollToDiv = document.querySelector('[data-feature-id="'+scrollToRelatedFeatureId+'"]');
        if ($scrollableDiv && scrollToArea && scrollToDiv) {
          const scrollTop = scrollToArea.offsetTop + scrollToDiv.offsetTop;
          // console.log("scrolling to div", scrollTop);
          $scrollableDiv.animate({scrollTop}, 800);
        }
      }, 0);
    }
  };

}
